import { useEffect } from "react";
import { Box } from "@mui/material";
import { Button } from "@mui/material";
import { getobj, dltobj } from "../apicall/apicall";
import { useState } from "react";
import {
  boxStyle,
  StyledTableCell,
  StyledTableRow,
  buttonPosition,
} from "../style/style";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import AddUsers from "./AddUsers";
import Pagination from "@mui/material/Pagination";
import { pageNo } from "../style/style";
import "react-notifications/lib/notifications.css";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";

export default function User(props) {
  const [users, setusers] = useState();
  const [adduser, setadduser] = useState(false);
  const [loaded, setloaded] = useState(true);
  const [page, setpage] = useState(1);
  const [totalpage, setpaget] = useState();
  const [refresh, setrefresh] = useState(false);

  const handlePagechange = (event, value) => {
    setloaded(true)
    setpage(value);
    const url =
      process.env.REACT_APP_ZEWA_URL +
      "user/add/" +
      props.id +
      "/?page=" +
      value;
    const d = getobj(url);
    d.then(function (res) {
      setusers(res.results);
      setloaded(false)
    });
  };

  // const handleClick = () => {
  //   const nm = getKeyByValue(context.page, true);
  //   context.setpage({
  //     ...context.page,
  //     [nm]: false,
  //     ["addUser"]: true,
  //   });
  // };

  useEffect(() => {
    let url;
    if (props.search === "") {
      url = process.env.REACT_APP_ZEWA_URL + "user/add/" + props.id + "/";
    } else {
      url =
        process.env.REACT_APP_ZEWA_URL +
        "user/search/" +props.id+"/"+
        "?search=" +
        props.search;
    }

    const d = getobj(url);
    d.then(function (res) {
      if (res) {
        setusers(res.results);
      }
      if (props.search === "") {
        if (res.count % 5 > 0) {
          setpaget(Math.floor(res.count / 5) + 1);
        } else {
          setpaget(Math.floor(res.count / 5));
        }
      } else {
        setpaget(1);
      }

     // console.log(res);
    });
    setloaded(false);
  }, [adduser, page, props.search, props.id, refresh]);

  const handleDelete = (id) => {
    const url = process.env.REACT_APP_ZEWA_URL + "user/add/0/";
    const res = dltobj(url, { id: id });
    res.then(function (data) {
      if (data["Message"] === "User Deleted Successfully") {
        NotificationManager.success("Successfully deleted.", "Deleted", 2000);
        setrefresh(!refresh);
      } else {
        NotificationManager.error("Could not delete.", "Failed", 2000);
      }
    });
  };

  return (
    <Box>
      {loaded ? (
        <img src="https://zewa-logo-bucket.s3.amazonaws.com/logo/Spinner-1s-200px.gif" alt="loading..." />
      ) : (
        <Box sx={boxStyle}>
          {!adduser && (
            <Box
              m={2}
              //margin
              sx={!adduser && buttonPosition}
            >
              <Button
                variant={!adduser && "contained"}
                color={!adduser && "primary"}
                style={{ fontFamily: "Roboto" }}
                startIcon={!adduser && <PersonAddAltIcon />}
                onClick={() => {
                  setadduser(!adduser);
                }}
              >
                Add user
              </Button>
            </Box>
          )}
          {!adduser ? (
            <Box>
              {users? (
                <TableContainer>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell>
                          <b>Name</b>
                        </StyledTableCell>
                        <StyledTableCell>
                          <b>Email</b>
                        </StyledTableCell>
                        <StyledTableCell>
                          <b>Phone</b>
                        </StyledTableCell>

                        <StyledTableCell></StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {users && users.map((user) => (
                        <StyledTableRow key={user.id}>
                          <StyledTableCell>{user.name}</StyledTableCell>
                          <StyledTableCell>{user.email}</StyledTableCell>
                          <StyledTableCell>{user.phone}</StyledTableCell>
                          <StyledTableCell
                            onClick={() => {
                              handleDelete(user.id);
                            }}
                          >
                            <Button variant="contained" color="error">
                              Delete
                            </Button>
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                "No User Added Yet."
              )}
            </Box>
          ) : (
            <AddUsers setadduser={setadduser} />
          )}
        </Box>
      )}
      <Pagination
        count={totalpage}
        page={page}
        variant="outlined"
        color="primary"
        onChange={handlePagechange}
        sx={pageNo}
      />
      <NotificationContainer />
    </Box>
  );
}
